import { observer } from 'mobx-react-lite'
import useStore from 'reusable/mobx-store-utils'
import { useParams } from 'react-router-dom'
import { notNull } from '@gap/utils/utils'
import { useAuthStore } from 'auth/AuthStore'
import useQueryWithHash from 'reusable/hooks/useQueryWithHash'
import Typography from '@mui/material/Typography'
import { themeConfig } from '@gap/shared/theme'
import ButtonWithProgress from 'reusable/mui/progress-button/ButtonWithProgress'
import AuthEmailLinkExpiredStore from './AuthEmailLinkExpiredStore'
import AuthInvalidToken from './AuthInvalidToken'

export default observer(function AuthEmailLinkExpired({ canRenewLink }: { canRenewLink: boolean }) {
   const { userId, token } = useParams()
   const queryString = useQueryWithHash()
   const authStore = useAuthStore()
   const emailId = notNull(queryString.get('emailId'))
   const authEmailLinkExpiredStore = useStore((sp) => new AuthEmailLinkExpiredStore(sp), { authStore, userId: notNull(userId), token: notNull(token), emailId })

   return <AuthInvalidToken canGoHome={!canRenewLink} text="This link has expired" content={
      <>
         <Typography variant="body1">Not to worry, we can send you a new link so you can carry on with your work.</Typography>
         {!authEmailLinkExpiredStore.newEmailLinkSent &&
            <ButtonWithProgress variant='contained' loading={authEmailLinkExpiredStore.loader.isLoading} onClick={authEmailLinkExpiredStore.requestNewEmailLink}>Send me a new link</ButtonWithProgress>
         }
         {authEmailLinkExpiredStore.newEmailLinkSent &&
            <Typography variant="body1Bold" sx={{ color: themeConfig.primary[900] }}>Please check your email for a new link.</Typography>
         }
      </>
   } />
})
